import { Component } from '@angular/core';
import { buildInfo } from '@/environments/build-info';
import { environment } from '@/environments/environment';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `
        <div class="layout-footer flex items-center gap-2 text-muted-color text-sm">
            @if (isProduction) {
                <span class="bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                    PROD
                </span>
            } @else {
                <span class="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                    DEV
                </span>
            }
            <span class="font-mono">{{ commit }} · {{ builtAt }}</span>
        </div>
    `,
})
export class AppFooter {
    readonly commit = buildInfo.commit;
    readonly builtAt = buildInfo.builtAt;
    readonly isProduction = environment.production;
}
